// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__QicMt","wrapper":"Nav_wrapper__t4MFi","section":"Nav_section__tbyA1","title":"Nav_title__lWAF-","item":"Nav_item__0xGv6","link":"Nav_link__Fh2Ii"};